
import {
  Directive,
  OnInit,
  OnDestroy,
  HostBinding,
  ElementRef,
  Optional,
  Self,
  HostListener,
  Input,
  AfterViewInit,
} from '@angular/core';
import { NgControl, NgForm, FormGroupDirective } from '@angular/forms';

@Directive({ standalone: false,
  selector: 'input[docInput], select[docInput]',
  exportAs: 'docInput',

})
export class InputDirective implements AfterViewInit {
  @HostBinding('attr.name') name: string;
  @HostBinding('attr.id') id: string;
  @HostBinding('attr.autocomplete') autocomplete = 'off';
  @HostBinding('attr.aria-autocomplete') airaAutocomplete = 'none';
  @HostBinding('class.form-control') protected formControl = true;
  @HostBinding('class.required') required = false;
  @HostBinding('class.only-email') onlyEmail = false;
  @HostBinding('class.email2') email2 = false;

  @HostBinding('class.visited') visit = false;

  @Input() messages;

  constructor(
    protected _elementRef: ElementRef<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    @Optional() @Self() public ngControl: NgControl
  ) {
    const element = this._elementRef.nativeElement;

    this.required = element.required;
  }

  ngAfterViewInit() {
    const element = this._elementRef.nativeElement;
    const autofocused = element.hasAttribute('autofocus');
    if (autofocused) {
      setTimeout(() => this._elementRef.nativeElement.focus());
    }
  }

  @HostListener('focusout', ['$event'])
  blur(event: Event) {
    this.visit = true;
    setTimeout(() => (this.messages.show = true), 200);
  }
}
